/* Accounting and revenue share (docs/plans/phase3-accounting-and-revenue-share.md §6).
 * Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.numbers {
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  font: var(--t-body-strong);
}

.facts dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
}

.pickerRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0 var(--space-4);
  width: 100%;
}

.pickerName {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}
